export default __webpack_public_path__ + "static/media/imagine_dream_front.17cf9183.gif";